import { Routes } from '@angular/router';
import { logRedirectGuard, RmaEmptyComponent } from '@rma/generic/util/router-utils';

import { communicationRoutes } from './communication.routes';

export const redirectRoutes: Routes = [
  // Redirects

  // Remove after 2024-06-30 ( check track js for logs)
  {
    path: 'communication',
    children: communicationRoutes,
  },
  // Remove after 2024-06-30 ( check track js for logs)
  {
    path: 'reporting',
    canActivate: [logRedirectGuard('/monitoring/online-performance')],
    component: RmaEmptyComponent,
  },
];
